// Nombre d'articles par page de la liste du blog (/blog, /blog/page/2…).
export const BLOG_PER_PAGE = 10;

export const blogPageCount = (total) => Math.max(1, Math.ceil(total / BLOG_PER_PAGE));

export const blogPagePath = (page) => (page <= 1 ? "/blog" : `/blog/page/${page}`);
